<template>
    <div class="filter__controls border rounded p-lg-4">
        <div class="filter__scroll">
            <!-- Skeleton loading - only shown during initial load -->
            <div v-if="isInitialLoad" class="filter-skeleton p-4 p-lg-0">
                <div class="skeleton-pulse"></div>
                <!-- Mobile header skeleton -->
                <div class="d-lg-none">
                    <div class="row align-items-center mb-4">
                        <div class="col-3 d-flex align-items-center">
                            <div class="skeleton-circle"></div>
                        </div>
                        <div class="col-7">
                            <div class="skeleton-text skeleton-title"></div>
                        </div>
                    </div>
                </div>

                <!-- Save Filter Controls skeleton -->
                <div class="mb-4">
                    <div class="skeleton-text"></div>
                    <div class="skeleton-text skeleton-text-sm"></div>
                </div>

                <!-- Status skeleton -->
                <div class="mb-4">
                    <div class="skeleton-text skeleton-title"></div>
                    <div class="skeleton-check-item"></div>
                    <div class="skeleton-check-item"></div>
                    <div class="skeleton-check-item"></div>
                </div>

                <!-- Volvo Selekt, VAT deductible, In stock skeleton -->
                <div class="mb-4">
                    <div class="skeleton-check-item"></div>
                    <div class="skeleton-check-item"></div>
                    <div class="skeleton-check-item"></div>
                </div>

                <!-- Showrooms skeleton -->
                <div class="mb-4">
                    <div class="skeleton-text skeleton-title"></div>
                    <div class="skeleton-check-item"></div>
                    <div class="skeleton-check-item"></div>
                </div>

                <!-- Models skeleton -->
                <div class="mb-4">
                    <div class="skeleton-text skeleton-title"></div>
                    <div class="skeleton-check-item skeleton-check-item-image"></div>
                    <div class="skeleton-check-item skeleton-check-item-image"></div>
                    <div class="skeleton-check-item skeleton-check-item-image"></div>
                </div>

                <!-- Fuel Type skeleton -->
                <div class="mb-4">
                    <div class="skeleton-text skeleton-title"></div>
                    <div class="skeleton-check-item"></div>
                    <div class="skeleton-check-item"></div>
                </div>

                <!-- Transmission Type skeleton -->
                <div class="mb-4">
                    <div class="skeleton-text skeleton-title"></div>
                    <div class="skeleton-check-item"></div>
                    <div class="skeleton-check-item"></div>
                </div>

                <!-- Mileage skeleton -->
                <div class="mb-4">
                    <div class="skeleton-text skeleton-title"></div>
                    <div class="skeleton-slider"></div>
                    <div class="skeleton-check-item"></div>
                    <div class="skeleton-check-item"></div>
                </div>

                <!-- Age skeleton -->
                <div class="mb-4">
                    <div class="skeleton-text skeleton-title"></div>
                    <div class="skeleton-slider"></div>
                    <div class="skeleton-check-item"></div>
                    <div class="skeleton-check-item"></div>
                </div>

                <!-- Price skeleton -->
                <div class="mb-4">
                    <div class="skeleton-text skeleton-title"></div>
                    <div class="skeleton-slider"></div>
                    <div class="skeleton-check-item"></div>
                    <div class="skeleton-check-item"></div>
                </div>

                <!-- Categories skeleton -->
                <div class="mb-4">
                    <div class="skeleton-text skeleton-title"></div>
                    <div class="skeleton-check-item"></div>
                    <div class="skeleton-check-item"></div>
                </div>

                <!-- Body Type skeleton -->
                <div class="mb-4">
                    <div class="skeleton-text skeleton-title"></div>
                    <div class="skeleton-check-item skeleton-check-item-image"></div>
                    <div class="skeleton-check-item skeleton-check-item-image"></div>
                </div>

                <!-- Body Color skeleton -->
                <div class="mb-4">
                    <div class="skeleton-text skeleton-title"></div>
                    <div class="skeleton-check-item"></div>
                    <div class="skeleton-check-item"></div>
                </div>

                <!-- Additional Attributes Button skeleton -->
                <div class="mb-4">
                    <div class="skeleton-button"></div>
                </div>
            </div>

            <!-- Loading overlay for subsequent loads -->
            <!--            <div v-else-if="loading && !isInitialLoad" class="position-relative">-->
            <!--                <div class="loading-overlay">-->
            <!--                    <div class="overlay-backdrop"></div>-->
            <!--                    <div class="spinner-container d-flex align-items-center">-->
            <!--                        <svg class="spinner-icon me-3" viewBox="0 0 50 50">-->
            <!--                            <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"/>-->
            <!--                        </svg>-->
            <!--                    </div>-->
            <!--                </div>-->

            <!--                &lt;!&ndash; Show existing content with overlay &ndash;&gt;-->
            <!--                <fieldset class="filter__controls-container p-4 p-lg-0 opacity-50">-->
            <!--                    &lt;!&ndash; Mobile header &ndash;&gt;-->
            <!--                    <div class="d-lg-none">-->
            <!--                        <div class="row align-items-center mb-4">-->
            <!--                            <div class="col-3 d-flex align-items-center">-->
            <!--                                <button id="hideFilter" class="btn-transparent px-0" @click="$emit('hide-filter')">-->
            <!--                                    <img src="/images/icons/ico-arrow-left.svg" alt="" class="icon icon&#45;&#45;w32" />-->
            <!--                                </button>-->
            <!--                            </div>-->
            <!--                            <div class="col-7">-->
            <!--                                <h2 class="h3 text-center mb-0">{{ propsData.mobileFilterTitle }}</h2>-->
            <!--                            </div>-->
            <!--                        </div>-->
            <!--                    </div>-->

            <!--                    &lt;!&ndash; Simplified content during loading &ndash;&gt;-->
            <!--                    <div class="mb-4">-->
            <!--                        <SavedFilterControls-->
            <!--                            :saveFilterLabel="propsData.saveFilterLabel || 'Uložit filtr'"-->
            <!--                            :saveFilterNoteLabel="propsData.saveFilterNoteLabel || 'Uložte si filtr a dostávejte upozornění na nové vozy'"-->
            <!--                        />-->
            <!--                    </div>-->

            <!--                    &lt;!&ndash; Show existing filters with reduced opacity &ndash;&gt;-->
            <!--                    <div v-for="(_, index) in 8" :key="index" class="mb-4">-->
            <!--                        <div class="skeleton-text skeleton-title"></div>-->
            <!--                        <div class="skeleton-check-item"></div>-->
            <!--                        <div class="skeleton-check-item"></div>-->
            <!--                    </div>-->
            <!--                </fieldset>-->
            <!--            </div>-->

            <!-- Actual content when not loading -->
            <fieldset v-else :disabled="loading" class="filter__controls-container p-4 p-lg-0">
                <!-- Mobile header -->
                <div class="d-lg-none">
                    <div class="row align-items-center mb-4">
                        <div class="col-3 d-flex align-items-center">
                            <button id="hideFilter" class="btn-transparent px-0" @click="$emit('hide-filter')">
                                <img src="/images/icons/ico-arrow-left.svg" alt="" class="icon icon--w32" />
                            </button>
                        </div>
                        <div class="col-7">
                            <h2 class="h3 text-center mb-0">{{ propsData.mobileFilterTitle }}</h2>
                        </div>
                    </div>
                </div>

                <!-- Save Filter Controls -->
                <div class="mb-4">
                    <SavedFilterControls
                        :saveFilterLabel="propsData.saveFilterLabel || 'Uložit filtr'"
                        :saveFilterNoteLabel="propsData.saveFilterNoteLabel || 'Uložte si filtr a dostávejte upozornění na nové vozy'"
                    />
                </div>

                <!-- Brands -->
                <div class="mb-4" v-if="options.brands && options.brands.length > 1">
                    <strong class="d-block text--grey text--350 text--uppercase filter--header space-bottom-xs lh-1">
                        {{ propsData.brandLabel || 'Značka' }}
                    </strong>
                    <div>
                        <div
                            v-for="brand in options.brands"
                            :key="brand.id"
                            class="form-check"
                        >
                            <input
                                v-model="filters.brands"
                                :value="brand.id"
                                :disabled="!presentData.brands[brand.id]"
                                class="form-check-input"
                                type="checkbox"
                                :id="`filter--brand-${brand.id}`"
                            />
                            <label
                                class="form-check-label text-primary"
                                :for="`filter--brand-${brand.id}`"
                            >
                                {{ brand.name }}
                                <span>({{ presentData.brands[brand.id] || 0 }})</span>
                            </label>
                        </div>
                    </div>
                </div>

                <!-- Status (availability types) -->
                <div class="mb-4">
                    <div class="filter__group filter__group--special">
                        <strong class="d-block text--grey text--350 text--uppercase filter--header space-bottom-xs lh-1">
                            {{ propsData.statusLabel }}
                        </strong>
                        <div>
                            <div
                                v-for="model in options.availabilityTypes"
                                :key="model.id"
                                class="form-check"
                            >
                                <input
                                    v-model="filters.availabilityTypes"
                                    :value="model.id"
                                    :disabled="!presentData.availabilityTypes[model.id]"
                                    class="form-check-input"
                                    type="checkbox"
                                    :id="`filter--availability-type-${model.id}`"
                                />
                                <label
                                    class="form-check-label text-primary"
                                    :for="`filter--availability-type-${model.id}`"
                                >
                                    {{ model.name }}
                                    <span>({{ presentData.availabilityTypes[model.id] || 0 }})</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Volvo Selekt, VAT deductible, In stock -->
                <div class="mb-4">
<!--                    <div class="form-check mb-2">-->
<!--                        <input-->
<!--                            v-model="filters.volvoSelektOnly"-->
<!--                            :value="true"-->
<!--                            :disabled="presentData.volvoSelekt === 0"-->
<!--                            class="form-check-input"-->
<!--                            type="checkbox"-->
<!--                            id="filter&#45;&#45;volvo-selekt"-->
<!--                        />-->
<!--                        <label class="form-check-label" for="filter&#45;&#45;volvo-selekt">-->
<!--                            <span class="badge badge&#45;&#45;select text-uppercase">-->
<!--                                {{ propsData.badgeVolvoSelekt }}-->
<!--                            </span>-->
<!--                            <span>({{ presentData.volvoSelekt }})</span>-->
<!--                            <span class="volvo-selekt-tooltip-trigger" @click.prevent="showVolvoSelectTooltip">-->
<!--                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-question-circle" viewBox="0 0 16 16">-->
<!--                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>-->
<!--                                    <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>-->
<!--                                </svg>-->
<!--                                <div class="volvo-selekt-tooltip-content" v-html="propsData.volvoSelektTooltip"></div>-->
<!--                            </span>-->
<!--                        </label>-->
<!--                    </div>-->
                    <div class="form-check">
                        <input
                            v-model="filters.vatDeductibleOnly"
                            class="form-check-input"
                            type="checkbox"
                            :disabled="presentData.vatDeductible === 0"
                            id="filter--vat-deductible"
                        />
                        <label class="form-check-label" for="filter--vat-deductible">
                            {{ propsData.badgeVatDeductible }}
                            <span>({{ presentData.vatDeductible }})</span>
                        </label>
                    </div>
<!--                    <div class="form-check">-->
<!--                        <input-->
<!--                            v-model="filters.isInStock"-->
<!--                            class="form-check-input"-->
<!--                            type="checkbox"-->
<!--                            :disabled="presentData.inStock === 0"-->
<!--                            id="filter&#45;&#45;in-stock"-->
<!--                        />-->
<!--                        <label class="form-check-label" for="filter&#45;&#45;in-stock">-->
<!--                            {{ propsData.badgeInStock }}-->
<!--                            <span>({{ presentData.inStock }})</span>-->
<!--                        </label>-->
<!--                    </div>-->
                </div>

                <!-- Custom Tags -->
                <div v-if="options.customTags && options.customTags.length" class="mb-4">
                    <strong class="d-block text--grey text--350 text--uppercase filter--header space-bottom-xs lh-1">
                        {{ propsData.actionDealsLabel }}
                    </strong>
                    <div>
                        <div
                            v-for="tag in options.customTags"
                            :key="tag.id"
                            class="form-check"
                        >
                            <input
                                v-model="filters.customTags"
                                :value="tag.id"
                                class="form-check-input"
                                type="checkbox"
                                :disabled="!presentData.customTags || !presentData.customTags[tag.id.toString()]"
                                :id="`filter--custom-tag-${tag.id}`"
                            />
                            <label class="form-check-label" :for="`filter--custom-tag-${tag.id}`">
                                {{ tag.title }} <span>({{ (presentData.customTags && presentData.customTags[tag.id.toString()]) || 0 }})</span>
                            </label>
                        </div>
                    </div>
                </div>

                <!-- Showrooms -->
                <div class="mb-4">
                    <strong class="d-block text--grey text--350 text--uppercase filter--header space-bottom-xs lh-1">
                        {{ propsData.showroomLabel }}
                    </strong>
                    <div class="filterChecksList">
                        <div
                            v-for="showroom in options.showrooms"
                            :key="showroom.id"
                            class="form-check"
                        >
                            <input
                                v-model="filters.showrooms"
                                :value="showroom.id"
                                class="form-check-input"
                                type="checkbox"
                                :disabled="!presentData.showrooms[showroom.id]"
                                :id="`filter--showroom-${showroom.id}`"
                            />
                            <label class="form-check-label" :for="`filter--showroom-${showroom.id}`">
                                {{ showroom.name }} <span>({{ presentData.showrooms[showroom.id] || 0 }})</span>
                            </label>
                        </div>
                    </div>
                </div>

                <!-- Models -->
                <div class="mb-4">
                    <strong class="d-block text--grey text--350 text--uppercase filter--header space-bottom-xs lh-1">
                        {{ propsData.modelLabel }}
                    </strong>
                    <div class="filterChecksList">
                        <div
                            v-for="(model, index) in options.models"
                            :key="model.id"
                            :class="['form-check', 'form-check--image', { 'd-none': index > 5 && !showAllModels }]"
                        >
                            <input
                                v-model="filters.models"
                                :value="model.id"
                                class="form-check-input"
                                type="checkbox"
                                :disabled="!presentData.models[model.id]"
                                :id="`filter--model-${model.id}`"
                            />
                            <label class="form-check-label" :for="`filter--model-${model.id}`">
                                <div class="form-check__image form-check__image--68">
                                    <img
                                        :src="model.iconUrl
                      ? (model.iconUrl.startsWith('http') || model.iconUrl.startsWith('/') ? model.iconUrl : `/${model.iconUrl}`)
                      : '/images/placeholder-model.png'"
                                        :alt="model.name"
                                    />
                                </div>
                                {{ model.name }} <span>({{ presentData.models[model.id] || 0 }})</span>
                            </label>
                        </div>
                        <button
                            v-if="!showAllModels && options.models.length > 6"
                            @click="showAllModels = true"
                            class="filterChecksList__showBtn btn-text text--small text--grey"
                        >
                            {{ propsData.moreValuesText.replace('__COUNT__', options.models.length - 6) }}
                        </button>
                    </div>
                </div>

                <!-- Fuel Type -->
                <div class="mb-4">
                    <strong class="d-block text--grey text--350 text--uppercase filter--header space-bottom-xs lh-1">
                        {{ propsData.fuelTypeLabel }}
                    </strong>
                    <div v-for="fuel in options.fuelTypes" :key="fuel.id" class="form-check">
                        <input
                            v-model="filters.fuelTypes"
                            :value="fuel.id"
                            class="form-check-input"
                            type="checkbox"
                            :disabled="!presentData.fuelTypes[fuel.id]"
                            :id="`fuel-${fuel.id}`"
                        />
                        <label class="form-check-label" :for="`fuel-${fuel.id}`">
                            {{ fuel.name }} ({{ presentData.fuelTypes[fuel.id] || 0 }})
                        </label>
                    </div>
                </div>

                <!-- Transmission Type -->
                <div class="mb-4">
                    <strong class="d-block text--grey text--350 text--uppercase filter--header space-bottom-xs lh-1">
                        {{ propsData.transmissionTypeLabel }}
                    </strong>
                    <div v-for="tr in options.transmissionTypes" :key="tr.id" class="form-check">
                        <input
                            v-model="filters.transmissionTypes"
                            :value="tr.id"
                            class="form-check-input"
                            type="checkbox"
                            :disabled="!presentData.transmissionTypes[tr.id]"
                            :id="`tt-${tr.id}`"
                        />
                        <label class="form-check-label" :for="`tt-${tr.id}`">
                            {{ tr.name }} ({{ presentData.transmissionTypes[tr.id] || 0 }})
                        </label>
                    </div>
                </div>

                <!-- Mileage (slider) -->
                <div class="mb-4">
                    <strong class="d-block text--grey text--350 text--uppercase filter--header space-bottom-xs lh-1">
                        {{ propsData.mileageLabel }}
                    </strong>
                    <DualRangeSlider
                        v-model="localMileageRange"
                        :min="0"
                        :max="sliderMaxMileage"
                        :step="10000"
                        :format="v => `${v.toLocaleString()} km`"
                    />
                </div>
                <!-- Mileage -->
                <div class="mb-4">
                    <!-- <strong class="d-block text--grey text--350 text--uppercase filter--header space-bottom-xs lh-1">{{ propsData.mileageLabel }}</strong>-->
                    <div
                        v-for="(count, range) in presentData.mileageRanges"
                        :key="range"
                        class="form-check"
                    >
                        <input
                            class="form-check-input"
                            type="radio"
                            :id="`mileage-${range}`"
                            :value="range"
                            v-model="modelSelectedMileageRange"
                            :disabled="count === 0"
                        />
                        <label class="form-check-label" :for="`mileage-${range}`">
                            {{ formatRange(range, mileageRangesTranslations) }} ({{ count }})
                        </label>
                    </div>
                </div>

                <!-- Age (slider) -->
                <div class="mb-4">
                    <strong class="d-block text--grey text--350 text--uppercase filter--header space-bottom-xs lh-1">
                        {{ propsData.ageLabel }}
                    </strong>
                    <DualRangeSlider
                        v-model="localYearRange"
                        :min="sliderMinYear"
                        :max="sliderMaxYear"
                        :step="1"
                        :format="v => v.toString()"
                    />
                </div>
                <!-- Age -->
                <div class="mb-4">
                    <!-- <strong class="d-block text--grey text--350 text--uppercase filter--header space-bottom-xs lh-1">{{ propsData.ageLabel }}</strong>-->
                    <div
                        v-for="(count, range) in presentData.ageRanges"
                        :key="range"
                        class="form-check"
                    >
                        <input
                            class="form-check-input"
                            type="radio"
                            :id="`age-${range}`"
                            :value="range"
                            v-model="modelSelectedAgeRange"
                            :disabled="count === 0"
                        />
                        <label class="form-check-label" :for="`age-${range}`">
                            {{ formatRange(range, ageRangesTranslations) }} ({{ count }})
                        </label>
                    </div>
                </div>

                <!-- Price -->
                <div class="mb-4">
                    <strong class="d-block text--grey text--350 text--uppercase filter--header space-bottom-xs lh-1">
                        {{ propsData.priceLabel }}
                    </strong>

                    <PriceHistogramSlider
                        :min="props.histogram.min"
                        :max="props.histogram.max"
                        :bars="props.histogram.histogram"
                        :step="props.histogram.step"
                        v-model="localPriceRange"
                    />

                    <div
                        v-for="(count, range) in presentData.priceRanges"
                        :key="range"
                        class="form-check"
                    >
                        <input
                            class="form-check-input"
                            type="radio"
                            :id="`price-${range}`"
                            :value="range"
                            v-model="modelSelectedPriceRange"
                            :disabled="count === 0"
                        />
                        <label class="form-check-label" :for="`price-${range}`">
                            {{ formatRange(range, priceRangesTranslations) }} ({{ count }})
                        </label>
                    </div>
                </div>

                <!-- Categories -->
                <div class="mb-4" v-if="options.categories && options.categories.length">
                    <strong class="d-block text--grey text--350 text--uppercase filter--header space-bottom-xs lh-1">
                        {{ propsData.categoryLabel || 'Kategorie' }}
                    </strong>
                    <div class="filterChecksList">
                        <div
                            v-for="(category, index) in options.categories"
                            :key="category.id"
                            :class="['form-check', { 'd-none': index > 5 && !showAllCategories }]"
                        >
                            <input
                                v-model="filters.categories"
                                :value="category.id"
                                class="form-check-input"
                                type="checkbox"
                                :disabled="!presentData.categories || !presentData.categories[category.id.toString()]"
                                :id="`filter--category-${category.id}`"
                            />
                            <label class="form-check-label" :for="`filter--category-${category.id}`">
                                {{ category.name }} <span>({{ (presentData.categories && presentData.categories[category.id.toString()]) || 0 }})</span>
                            </label>
                        </div>
                        <button
                            v-if="!showAllCategories && options.categories.length > 6"
                            @click="showAllCategories = true"
                            class="filterChecksList__showBtn btn-text text--small text--grey"
                        >
                            {{ propsData.moreValuesText.replace('__COUNT__', options.categories.length - 6) }}
                        </button>
                    </div>
                </div>

                <!-- Body Type -->
                <div class="mb-4">
                    <strong class="d-block text--grey text--350 text--uppercase filter--header space-bottom-xs lh-1">
                        {{ propsData.bodyTypeLabel }}
                    </strong>
                    <div class="filterChecksList">
                        <div
                            v-for="(bt, i) in options.bodyTypes"
                            :key="bt.id"
                            :class="['form-check','form-check--image',{ 'd-none': i>5 && !showAllBodyTypes }]"
                        >
                            <input
                                v-model="filters.bodyTypes"
                                :value="bt.id"
                                class="form-check-input"
                                type="checkbox"
                                :disabled="!presentData.bodyTypes[bt.id]"
                                :id="`filter--body-type-${bt.id}`"
                            />
                            <label class="form-check-label" :for="`filter--body-type-${bt.id}`">
                                <div class="form-check__image">
                                    <img :src="`/images/mg/icons/ico-type-${bt.id}-v2.svg`" :alt="bt.name" />
                                </div>
                                {{ bt.name }} <span>({{ presentData.bodyTypes[bt.id] || 0 }})</span>
                            </label>
                        </div>
                        <button
                            v-if="!showAllBodyTypes && options.bodyTypes.length>6"
                            @click="showAllBodyTypes=true"
                            class="filterChecksList__showBtn btn-text text--small text--grey"
                        >
                            {{ propsData.moreValuesText.replace('__COUNT__', options.bodyTypes.length - 6) }}
                        </button>
                    </div>
                </div>

                <!-- Body Color -->
                <div class="mb-4">
                    <strong class="d-block text--grey text--350 text--uppercase filter--header space-bottom-xs lh-1">
                        {{ propsData.bodyColorLabel }}
                    </strong>
                    <div class="filterChecksList">
                        <div
                            v-for="(bc, idx) in options.bodyColors"
                            :key="bc.id"
                            :class="['mb-3', 'form-check', { 'd-none': idx>5 && !showAllBodyColors }]"
                        >
                            <input
                                v-model="filters.bodyColors"
                                :value="bc.id"
                                class="form-check-input"
                                type="checkbox"
                                :disabled="!presentData.bodyColors[bc.id]"
                                :id="`filter--body-color-${bc.id}`"
                            />
                            <label class="form-check-label" :for="`filter--body-color-${bc.id}`">
                                <div class="me-2">
                                    <div
                                        v-if="bc.is_metallic"
                                        :style="{
                                            background: `linear-gradient(180deg, color-mix(in srgb,${bc.hex}, #fff 20%), color-mix(in srgb,${bc.hex}, #000 20%)`,
                                            border: 'solid 0.5px #afafaf',
                                            borderRadius: '50%',
                                            padding: '0.6rem'
                                        }"
                                    ></div>
                                    <div
                                        v-else
                                        :style="{
                                            backgroundColor: bc.hex,
                                            border: 'solid 0.5px #afafaf',
                                            borderRadius: '50%',
                                            padding: '0.6rem'
                                        }"
                                    ></div>
                                </div>
                                {{ bc.name.charAt(0).toUpperCase() + bc.name.slice(1) }} <span>({{ presentData.bodyColors[bc.id] || 0 }})</span>
                            </label>
                        </div>
                        <button
                            v-if="!showAllBodyColors && options.bodyColors.length>6"
                            @click="showAllBodyColors=true"
                            class="filterChecksList__showBtn btn-text text--small text--grey"
                        >
                            {{ propsData.moreValuesText.replace('__COUNT__', options.bodyColors.length - 6) }}
                        </button>
                    </div>
                </div>

                <!-- Additional Attributes Button -->
                <div class="mb-4" v-if="options.additionalAttributes && options.additionalAttributes.length">
                    <button
                        class="btn btn-outline-primary btn-sm w-100"
                        @click="showAdditionalAttributesModal"
                    >
                        {{ propsData.additionalAttributesButtonLabel || 'Additional Attributes' }}
                    </button>
                </div>

                <!-- Additional Attributes Modal -->
                <AdditionalAttributesModal
                    ref="additionalAttributesModal"
                    :attributes="options.additionalAttributes"
                    v-model="filters.additionalAttributes"
                    :title-long="propsData.additionalAttributesModalTitleLong || 'Additional Attributes'"
                    :title-short="propsData.additionalAttributesModalTitleShort || 'Additional'"
                    :btn-cancel="propsData.additionalAttributesModalBtnCancel || 'Cancel'"
                    :btn-save="propsData.additionalAttributesModalBtnSave || 'Apply'"
                    :counts="presentData.additionalAttributes"
                    @apply="applyAdditionalAttributes"
                />

            </fieldset>
        </div>

        <!-- Mobile floating buttons -->
        <div class="filter__floating-btns d-flex justify-content-center d-lg-none">
            <div class="d-flex w-100">
                <button
                    class="btn btn-light px-1 w-100 text-nowrap"
                    @click="$emit('clear-filters')"
                    title="Remove filter"
                >
                    <img src="/images/mg/icons/ico-close-grey.svg" alt="" class="pe-2 pb-1">
                    {{ propsData.clearAllLabel }}
                </button>
                <button
                    id="showResults"
                    class="btn btn-primary text-nowrap padding-x-32px ms-2"
                    @click="$emit('hide-filter')"
                    title="Show results"
                >
                    {{ propsData.showMoreResults }} ({{ propsData.total }})
                </button>
            </div>
        </div>
    </div>

    <!-- Volvo Selekt Modal (shown on mobile) -->
    <VolvoSelektModal
        :is-visible="isModalVisible"
        :tooltip-content="propsData.volvoSelektTooltip"
        :badge-text="propsData.badgeVolvoSelekt"
        @close="isModalVisible = false"
    />
</template>

<script setup>
import PriceHistogramSlider from '@/components/CarFilter/SiteSpecific/orbion/PriceHistogramSlider.vue'
import DualRangeSlider from '@/components/CarFilter/SiteSpecific/orbion/DualRangeSlider.vue'
import AdditionalAttributesModal from '@/components/CarFilter/AdditionalAttributesModal.vue'
import SavedFilterControls from '@/components/CarFilter/SavedFilterControls.vue'
import VolvoSelektModal from '@/components/CarFilter/VolvoSelektModal.vue'
import { useCarFilterSidebar } from '@/composables/useCarFilterSidebar'
const props = defineProps({
    filters: Object,
    options: Object,
    presentData: Object,
    loading: Boolean,
    isInitialLoad: Boolean,
    propsData: Object,
    formatRange: Function,
    mileageRangesTranslations: Object,
    ageRangesTranslations: Object,
    priceRangesTranslations: Object,
    selectedMileageRange: String,
    selectedAgeRange: String,
    selectedPriceRange: String,
    additionalAttributesButtonLabel: String,
    additionalAttributesModalTitleLong: String,
    additionalAttributesModalTitleShort: String,
    additionalAttributesModalBtnCancel: String,
    additionalAttributesModalBtnSave: String,
    histogram: {
        type: Object,
        required: true   // { min: number, max: number, histogram: Array }
    },
    maxMileage: {
        type: Number,
        required: true
    },
    maxAge: {
        type: Number,
        required: true
    }
})

const emit = defineEmits([
    'update-filters',
    'update:selectedMileageRange',
    'update:selectedAgeRange',
    'update:selectedPriceRange',
    'hide-filter',
    'clear-filters',
])

// Use the composable for shared logic
const {
    toggleAdditionalAttribute,
    toggleAttributeOption,
    isOptionSelected,
    additionalAttributesModal,
    isModalVisible,
    showAdditionalAttributesModal,
    showVolvoSelectTooltip,
    handleDocumentClick,
    applyAdditionalAttributes,
    modelSelectedMileageRange,
    modelSelectedAgeRange,
    modelSelectedPriceRange,
    showShowrooms,
    showAllModels,
    showAllBodyTypes,
    showAllBodyColors,
    showAllCategories,
    localPriceRange,
    sliderMaxMileage,
    localMileageRange,
    minYear,
    currentYear,
    sliderMinYear,
    sliderMaxYear,
    localYearRange
} = useCarFilterSidebar(props, emit)
</script>

<style scoped>

/* Volvo Select tooltip styles */
.volvo-selekt-tooltip-trigger {
    position: relative;
    cursor: help !important;
    padding: 0 5px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-weight: inherit !important;
}

.volvo-selekt-tooltip-content {
    display: none;
    position: absolute;
    top: 30px;
    left: -10px;
    text-wrap: nowrap;
    transform: translateX(0);
    background: #303e4f;
    color: #fff;
    padding: 10px;
    border-radius: 4px;
    white-space: normal;
    font-size: 12px;
    opacity: 0;
    visibility: hidden;
    z-index: 1000;
    transition: opacity 0.5s ease, visibility 0.5s ease;
    text-align: left;
    line-height: 1.5;
    min-width: 340px;
}

.volvo-selekt-tooltip-content p {
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 5px;
    padding-left: 10px;
}

.volvo-selekt-tooltip-content ul {
    padding-left: 20px;
    margin-bottom: 0;
}

.volvo-selekt-tooltip-content::after {
    content: '';
    position: absolute;
    top: -20px;
    left: 15px;
    border-width: 10px;
    border-style: solid;
    border-color: transparent transparent #303e4f transparent;
    width: 0;
    height: 0;
}

.volvo-selekt-tooltip-trigger.active .volvo-selekt-tooltip-content {
    display: block;
    opacity: 1;
    visibility: visible;
}

@media (max-width: 768px) {
    .volvo-selekt-tooltip-content {
        display: none !important;
        max-width: 320px;
    }
}

@media (max-width: 900px) {
    .volvo-selekt-tooltip-content {
        max-width: 340px;
        min-width: 300px;
    }
}

/* Mobile floating buttons */
:deep(.filter__floating-btns) {
    background: #f8f8f8;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100dvw; /* Use dynamic viewport width */
    padding: 16px 12px;
    padding-bottom: calc(16px + env(safe-area-inset-bottom, 0px)); /* Support for safe area */
    z-index: 105;
    pointer-events: all;
    box-sizing: border-box;
    /* Fix for mobile viewport issues */
    min-height: calc(68px + env(safe-area-inset-bottom, 0px));
}

:deep(.filter-active .filter__floating-btns) {
    left: 0;
    pointer-events: all;
}

:deep(body.modal-filter-active .filter__floating-btns) {
    pointer-events: none;
}

/* Additional mobile fixes for scrolling issues */
@media (max-width: 991.98px) {
    :deep(.filter__floating-btns) {
        /* Prevent issues with mobile browser UI changes */
        position: fixed;
        transform: translateZ(0); /* Force GPU acceleration */
        -webkit-transform: translateZ(0);
        backface-visibility: hidden;
        -webkit-backface-visibility: hidden;
        /* Use 100vh fallback for older browsers, 100dvh for modern ones */
        bottom: env(safe-area-inset-bottom, 0px);
    }

    /* Ensure content doesn't get hidden behind the floating buttons */
    :deep(.filter__scroll) {
        padding-bottom: calc(84px + env(safe-area-inset-bottom, 0px));
    }
}

/* Mobile sidebar border */
@media (max-width: 991.98px) {
    .filter__controls-container {
        border-right: 1px solid #ccc !important;
    }
}
</style>
